import React from 'react';

import {
  PurchasedProductSummaryType,
  usePurchasedProducts,
} from '@portals/api/partners';
import { DashboardContentLayout } from '@portals/framework';
import {
  AvatarCell,
  BadgeCell,
  DateCell,
  PaginatedTable,
} from '@portals/table';
import { TableColumn, TableFilterTypeEnum } from '@portals/types';

import { PurchasedProductDetailsPanel } from './PurchasedProductDetailsPanel';

const COLUMNS: Array<TableColumn<PurchasedProductSummaryType>> = [
  {
    dataField: 'product_name',
    text: 'Name',
    sort: true,
    isSticky: true,
    filter: { type: TableFilterTypeEnum.Text },
    formatter: (_, { product }) => (
      <AvatarCell src={product.image_url} label={product.name} />
    ),
  },
  {
    dataField: 'product_category',
    text: 'Category',
    sort: true,
    filter: { type: TableFilterTypeEnum.Text },
    formatter: (_, { product }) =>
      product.category ? (
        <BadgeCell
          label={product.category}
          sx={(theme) => ({
            backgroundColor: theme.black,
            color: theme.white,
            fontWeight: 400,
            textTransform: 'uppercase',
          })}
        />
      ) : (
        '--'
      ),
  },
  {
    dataField: 'organization_display_name',
    text: 'Customer',
    sort: true,
    filter: { type: TableFilterTypeEnum.Text },
    formatter: (_, { buyer }) => (
      <AvatarCell
        src={buyer.logo_url}
        label={buyer.name || '--'}
        radius="md"
        withAbbreviation={Boolean(buyer.name)}
      />
    ),
  },
  {
    dataField: 'created_at',
    text: 'Purchase Date',
    sort: true,
    filter: { type: TableFilterTypeEnum.Date },
    formatter: (_, { created_at }) => <DateCell date={created_at} />,
  },
];

export const PurchasedProducts = () => {
  return (
    <DashboardContentLayout
      pageTitle="Purchased Products"
      breadcrumbs={[
        { label: 'Store Management', to: '/store-management' },
        { label: 'Purchased Products' },
      ]}
      bg="gray.0"
    >
      <PaginatedTable<PurchasedProductSummaryType>
        noHeader
        columns={COLUMNS}
        dataHook={usePurchasedProducts}
        noDataIndication={{ title: 'No devices' }}
        defaultSortBy={[{ id: 'created_at', desc: true }]}
        name="partners.devices"
        keyField="id"
        detailsPanel={{
          type: 'page',
          renderer: ({ row, onClose }) => (
            <PurchasedProductDetailsPanel
              onClose={onClose}
              purchasedProductId={row.original.id}
            />
          ),
        }}
      />
    </DashboardContentLayout>
  );
};
